var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMyRoom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 71,
  height: 18,
  viewBox: "0 0 71 18"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uBB34\uD55C\uCFE0\uD3F0\uB8F8 \uBC43\uC9C0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient-1",
  x1: "0%",
  x2: "99.492%",
  y1: "45%",
  y2: "45%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FF1069"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF493D"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "99\\uAE30\\uD0C0/01component/00.\\uBC43\\uC9C0-\\uD0C0\\uC785/\\uBB34\\uD55C\\uCFE0\\uD3F0\\uB8F8",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uBB34\\uD55C\\uCFE0\\uD3F0\\uB8F8-\\uBC43\\uC9C0"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  fill: "url(#linearGradient-1)",
  d: "M4 0h63a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uBB34\\uD55C\\uCFE0\\uD3F0\\uB8F8",
  fill: "#FFF",
  d: "M28.697 8.227V4.393h-6.3v3.832zM27.31 7.134h-3.518V5.487h3.518zm-1.113 6.206v-3.076h3.57V9.182h-8.453v1.082h3.507v3.076zm11.55-2.32V8.258h1.26V7.124h-1.26v-3.15h-1.376v7.046zm-3.255-5.765V4.237h-2.815v1.018zm1.291 1.449v-1.06h-5.46v1.06zm-2.709 3.686c1.344 0 2.258-.767 2.258-1.764 0-.987-.914-1.764-2.258-1.764-1.355 0-2.258.776-2.258 1.764 0 .997.914 1.764 2.258 1.764m0-1.03c-.525 0-.882-.346-.882-.734 0-.368.357-.756.882-.756.535 0 .892.388.892.756 0 .388-.356.735-.892.735m4.861 3.812v-1.103h-5.008v-1.386H31.5v2.489zm6.447.157V9.939h3.55V8.825h-1.397c.242-.976.41-2.488.41-3.822 0-.2 0-.41-.011-.609h-6.437v1.113h5.114v.2c0 .252-.01.503-.032.777-1.805.042-3.611.083-5.428.115l.157 1.186c1.733-.094 3.455-.168 5.188-.262-.053.494-.137.956-.221 1.302H39.48v1.113h3.528v3.391zm11.823-7.812V4.437h-6.835v1.082zm.809 4.578V8.983h-3.57V8.29h2.657V7.219h-1.197l.294-1.25-1.334-.147-.22 1.396h-1.712l-.189-1.396-1.312.136.199 1.26h-1.187V8.29h2.615v.693h-3.496v1.112zm-.977 2.993v-1.081h-5.081v-1.45H49.56v2.531zm9.104-4.882V7.145h-4.987v-.41h4.861V4.3h-6.269v1.029h4.883v.42h-4.893v2.457zm-.073 5.019v-2.899h-2.51V9.78h3.538V8.7h-8.452v1.082h3.538v.545h-2.52v2.899zm-1.408-1.05H60.04v-.799h3.622z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  fill: "#FFF",
  transform: "translate(4 5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillOpacity: 0.98,
  d: "M3.963 0Q5.546 0 7.56 1.961A20 20 0 0 0 5.957 3.75a20 20 0 0 0 1.604 1.788l.195-.194Q5.623 7.5 3.963 7.5C1.775 7.5 0 5.82 0 3.75S1.775 0 3.963 0m-.086 2.426C3 2.426 2.29 3.02 2.29 3.75s.71 1.324 1.586 1.324q.875 0 2.08-1.324-1.205-1.324-2.08-1.324"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillOpacity: 0.8,
  d: "M11.158 0c2.19 0 3.964 1.68 3.964 3.75S13.347 7.5 11.158 7.5q-1.553 0-3.52-1.888l-.077-.074A20 20 0 0 0 9.165 3.75a20 20 0 0 0-1.603-1.788Q9.577 0 11.158 0m.087 2.426q-.875 0-2.08 1.324 1.205 1.323 2.08 1.324c.876 0 1.586-.593 1.586-1.324s-.71-1.324-1.586-1.324"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  fillOpacity: 0.93,
  d: "M9.165 3.75A20 20 0 0 1 7.56 5.538 20 20 0 0 1 5.957 3.75a20 20 0 0 1 1.604-1.788q.77.75 1.603 1.788"
})))))));
export default SvgMyRoom;